import React, { Component } from 'react'
import EventTypeFilters from './EventTypeFilters';
import FilterBy from './FilterBy';
import SearchBox from './SearchBox'

class FilterToolbar extends Component {

    constructor(props) {
        super(props)

        this.state = {
            mobileMenuOpen: false
        }

        this.mobileFilterToggle = this.mobileFilterToggle.bind(this)
    }

    mobileFilterToggle(e) {
        e.preventDefault()

        this.setState({mobileMenuOpen: !this.state.mobileMenuOpen})
    }

    render() {
        return (
            <div className={`c-event-filters`} style={{zIndex: 5}}>
                <button onClick={this.mobileFilterToggle} className="c-event-filters__mobile-toggle c-btn c-btn--red" href="#"><i className="fal fa-sliders-h"></i> Filter</button>
                <h4 className="c-event-filters__title">Filter</h4>
                <div className={`c-event-filters__wrap faster ${this.state.mobileMenuOpen === true ? 'active fadeInDown' : ''}`}>
                    <div className="c-event-filter-set c-event-filter-set-types">
                        <button className="c-btn c-event-filter-set-types__toggle">Event Type <i className="far fa-angle-down"></i></button>
                        <div className="c-event-filter-set__description" aria-label="Filter by Event Type">Filter by Event Type</div>
                        <div className={`c-event-filter-set-types__types ${this.state.mobileMenuOpen === true ? 'active' : ''}`}>
                            <EventTypeFilters operator="and" attribute="attendable.eventType" />
                        </div>
                    </div>
                    <div className="c-event-filter-set c-event-filter-set-search">
                        <div className="c-event-filter-set__description" aria-label="Search Events">Search Events</div>
                        <SearchBox className="c-event-search-input" translations={{placeholder: 'Search Events'}} />
                    </div>
                    <div className="c-event-filter-set c-event-filter-set-dropdowns">
                        <div className="c-event-filter-set__description" aria-label="Filter by Date, Venue and Access">Filter by Date, Venue and Access</div>
                        <FilterBy />
                    </div>
                    <button type="submit" onClick={this.mobileFilterToggle} className="c-event-filters__mobile-submit c-btn c-btn--red" href="#">Apply Filters</button>
                </div>
            </div>
        )
    }

}

export default FilterToolbar



// WEBPACK FOOTER //
// ./src/whatson/components/FilterToolbar.js